// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"189729bc","419":"563cde9b","563":"d3517398","572":"ca7fc664","726":"2dba100f","787":"0979ab29"}[chunkId] + ".chunk.js";
};